import React from 'react';
import { Calendar } from 'primereact/calendar';

const ProfileAwardForm = ({ isOpen, onClose, onSubmit, formData, setFormData, units = [], degrees = [], titles = [], awardTypes = [], authorities = [], isEditing }) => {
    if (!isOpen) return null;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleDateChange = (name, dateObj) => {
        let dateString = '';
        if (dateObj) {
            const yyyy = dateObj.getFullYear();
            const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
            const dd = String(dateObj.getDate()).padStart(2, '0');
            dateString = `${yyyy}-${mm}-${dd}`;
        }
        handleChange({ target: { name, value: dateString } });
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
            <div className="modal-box form-modal-box" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <h3 style={{ margin: 0, paddingRight: '15px', lineHeight: '1.4' }}>
                        {isEditing ? "Cập nhật Danh hiệu - Giải thưởng" : "Thêm mới Thông tin danh hiệu - Giải thưởng"}
                    </h3>
                    <button
                        type="button"
                        className="close-btn"
                        onClick={onClose}
                        style={{ fontSize: '26px', lineHeight: '1', display: 'flex', flexShrink: 0, marginTop: '-2px' }}
                    >
                        &times;
                    </button>
                </div>

                <div className="modal-body" style={{ padding: '25px' }}>
                    <form id="awardForm" onSubmit={onSubmit}>
                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Đơn vị công tác *</label>
                            <select name="UnitName" className="form-input" value={formData.UnitName || ''} onChange={handleChange} required>
                                <option value="">Chọn đơn vị</option>
                                {units.map(u => <option key={u.Id} value={u.Name}>{u.Name}</option>)}
                            </select>
                        </div>

                        <div className="form-grid-2">
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Học vị *</label>
                                <select name="DegreeName" className="form-input" value={formData.DegreeName || ''} onChange={handleChange} required>
                                    <option value="">Chọn học vị</option>
                                    {degrees.map(d => <option key={d.Id} value={d.Name}>{d.Name}</option>)}
                                </select>
                            </div>
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Chức danh</label>
                                <select name="TitleName" className="form-input" value={formData.TitleName || ''} onChange={handleChange}>
                                    <option value="">Chọn chức danh</option>
                                    {titles.map(t => <option key={t.Id} value={t.Name}>{t.Name}</option>)}
                                </select>
                            </div>
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Chức vụ</label>
                            <input type="text" name="Position" className="form-input" value={formData.Position || ''} onChange={handleChange} placeholder="Hiệu trưởng, Trưởng khoa/phòng..." />
                        </div>

                        <div className="form-grid-2">
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Hình thức khen thưởng *</label>
                                <select name="AwardTypeName" className="form-input" value={formData.AwardTypeName || ''} onChange={handleChange} required>
                                    <option value="">Chọn hình thức khen thưởng</option>
                                    {awardTypes.map(a => <option key={a.Id} value={a.Name}>{a.Name}</option>)}
                                </select>
                            </div>
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Nơi cấp *</label>
                                <select name="IssuingAuthorityName" className="form-input" value={formData.IssuingAuthorityName || ''} onChange={handleChange} required>
                                    <option value="">Chọn nơi cấp</option>
                                    {authorities.map(a => <option key={a.Id} value={a.Name}>{a.Name}</option>)}
                                </select>
                            </div>
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Nội dung khen thưởng *</label>
                            <input type="text" name="AwardContent" className="form-input" value={formData.AwardContent || ''} onChange={handleChange} required />
                        </div>

                        <div className="form-grid-2">
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Số quyết định *</label>
                                <input type="text" name="DecisionNumber" className="form-input" value={formData.DecisionNumber || ''} onChange={handleChange} required />
                            </div>
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ngày ký *</label>
                                <Calendar
                                    id="SignatureDate"
                                    name="SignatureDate"
                                    value={(formData.SignatureDate && !isNaN(new Date(formData.SignatureDate).getTime())) ? new Date(formData.SignatureDate) : null}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    onChange={(e) => handleDateChange('SignatureDate', e.value)}
                                    style={{ width: '100%' }}
                                    appendTo={document.body}
                                    panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                    inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                    required
                                />
                            </div>
                        </div>
                    </form>
                </div>

                <div className="modal-footer" style={{ borderTop: '1px solid #eee', padding: '15px 25px' }}>
                    <button type="button" className="btn-cancel" onClick={onClose}>Hủy</button>
                    <button type="submit" form="awardForm" className="btn-submit">Hoàn tất</button>
                </div>
            </div>
        </div>
    );
};

export default ProfileAwardForm;